import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ nextReleaseDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const release = new Date(nextReleaseDate).getTime();
      const difference = release - now;

      if (difference > 0) {
        const hours = Math.floor((difference / (1000 * 60 * 60)));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ hours, minutes, seconds });
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // Calculate immediately
    calculateTimeLeft();
    
    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [nextReleaseDate]);

  // If all values are 0, content is ready
  const isContentReady = Object.values(timeLeft).every(value => value === 0);

  return (
    <div className="flex items-center space-x-2 text-sm bg-purple-100 p-3 rounded-lg">
      <Clock className="w-5 h-5 text-purple-600" />
      <div className="text-purple-800">
        {isContentReady ? (
          <span className="font-medium">New content available!</span>
        ) : (
          <span>
            Next lesson in:{' '}
            <span className="font-medium">
              {timeLeft.hours.toString().padStart(2, '0')}:
              {timeLeft.minutes.toString().padStart(2, '0')}:
              {timeLeft.seconds.toString().padStart(2, '0')}
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default CountdownTimer;
